import api from './api';

const authService = {
  // Complete Registration
  register: async (data) => {
    const response = await api.post('/auth/register', data);
    return response.data;
  },

  // Login
  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },

  // Forgot password (always returns success response from backend)
  forgotPassword: async ({ email }) => {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  // Reset password
  resetPassword: async ({ token, newPassword }) => {
    const response = await api.post('/auth/reset-password', { token, newPassword });
    return response.data;
  },

  // Create Admin
  createAdmin: async (data) => {
    const response = await api.post('/auth/create-admin', data);
    return response.data;
  },
};

export default authService;
